/* globals process */

export default {
	namespaced: true,
	state() {
		return {
			formData: {},
			currentStep: 1,
			completedStep: 0,
			totalSteps: 1,
			id: null,
		}
	},
	getters: {
		formData(state) {
			return state.formData;
		}
	},
	mutations: {
		/**
		 *
		 * @param state
		 */
		clear(state) {
			state.formData = {};
			state.currentStep = 1;
			state.completedStep = 0;
			state.totalSteps = 1;
			state.id = null;
		},

		/**
		 *
		 * @param state
		 * @param totalSteps
		 */
		setTotalSteps(state, totalSteps) {
			state.totalSteps = totalSteps;
			state.currentStep = Math.min(totalSteps, state.currentStep);
			state.completedStep = Math.min(totalSteps, state.completedStep);
		},

		setCompletedStep(state, step) {
			state.completedStep = Math.min(step, state.totalSteps);
		},

		setCurrentStep(state, step) {
			state.currentStep = step;
		},

		completeCurrentStep(state, step) {
			state.completedStep = state.currentStep;
		},

		nextStep(state) {
			if((state.currentStep <= state.completedStep) && (state.currentStep < state.totalSteps)) {
				state.currentStep++;
			}
		},

		previousStep(state) {
			if(state.currentStep > 1) {
				state.currentStep--;
			}
		},

		/**
		 *
		 * @param state
		 * @param step
		 */
		setId(state, id) {
			state.id = id;
		},

		/**
		 *
		 * @param state
		 * @param formData
		 */
		setFormData(state, formData) {
			state.formData = formData;
		},

		mergeFormData(state, formData) {
			state.formData = Object.assign(state.formData, formData);
		}
	},
}
